module.exports = __webpack_public_path__ + "static/media/high-five.3191cea1.svg";